import { Platform, StyleSheet } from 'react-native'
import { corporateColor, textColor, toqueColor, white, whiteBackgroundColor } from './colors'
import { DOBRA, DOBRA_BOLD, DOBRA_LIGTH } from './fonts'

export const globalStyle = StyleSheet.create({
  content: {
    flexGrow: 1,
    justifyContent: 'center',
  },

  containerImgBackground: {
    flex: 1,
  },

  imgBackground: {
    flex: 1,
    justifyContent: 'center',
  },

  textImgBackground: {
    color: 'white',
    fontSize: 42,
    lineHeight: 84,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: corporateColor,
  },

  contentContainer: {
    padding: 20,
    marginBottom: 50,
    flexGrow: 1,
    flex: 1,
  },

  imgLogo: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    height: 'auto',
    padding: 20,
    marginBottom: 40,
  },
  darkTitle: {
    color: white,
    fontSize: 33,
    fontFamily: DOBRA,
    textAlign: 'right',
  },
  darkSubtitle: {
    color: white,
    fontSize: 22,
    fontFamily: DOBRA_LIGTH,
    textAlign: 'right',
    ...(Platform.OS === 'android' ? {} : { paddingBottom: 10 }),
  },

  center: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    display: 'flex',
    padding: 20,
  },

  basicTitle: {
    fontFamily: DOBRA,
    fontSize: 18,
    textAlign: 'center',
    color: textColor,
  },

  viewContainer: {
    backgroundColor: white,
    padding: 10,
    flex: 1,
  },
})

export const loginStyle = StyleSheet.create({
  cardContainer: {
    borderRadius: 10,
    padding: 20,
    paddingTop: 30,
    backgroundColor: whiteBackgroundColor,
  },
  cardTitle: {
    fontSize: 18,
    textAlign: 'center',
    color: toqueColor,
    fontFamily: DOBRA_BOLD,
  },

  cardTitleLineSetting: {
    borderTopColor: toqueColor,
    borderTopWidth: 2,
    width: 30,
    marginBottom: 30,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 8,
  },
})
